import { Icon } from 'roadie-ui'

type ReturnRateIconProps = {
  scorecardBand: string
}

export const ReturnRateIcon: React.FC<ReturnRateIconProps> = ({ scorecardBand }) => {
  switch (scorecardBand) {
    case 'acceptable':
      return <Icon.CheckmarkCircle $color="success-base" $width="2.4rem" $height="2.4rem" />
    case 'coaching':
      return <Icon.AlertFilled $color="alert-base" $width="2.4rem" $height="2.4rem" />
    case 'abuser':
      return <Icon.AlertFilled $color="error-base" $width="2.4rem" $height="2.4rem" />
    default:
      return null
  }
}
